<template>
    <div class='t_content_view'>
        <div class="t_search_box" style="margin-bottom: 20px">
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input v-model="searchdata.username" size="small" placeholder="请输入账号名称"  clearable />
            </div>
            
            <el-button type="primary" color="#F1F3F9" @click="searchbtn()" style="margin-bottom: 10px;">查询</el-button>
            <el-button type="primary" color="#F1F3F9" @click="openwindow()" style="margin-bottom: 10px;">添加</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%">
            
            <el-table-column prop="username" label="账号" />
            <!-- <el-table-column prop="plain_password" label="密码" /> -->
            <el-table-column prop="nickname" label="昵称" />
            <el-table-column prop="sendNames" label="账号类型" >
                <template #default="scope">
                    <span v-if="scope.row.role==0">管理员</span>
                    <span v-if="scope.row.role==1">客服</span>
                    <span v-if="scope.row.role==2">运营者</span>
                </template>
            </el-table-column>
            <el-table-column prop="sendNames" label="在线状态" >
                <template #default="scope">
                    <span v-if="scope.row.online_status==0">挂起休息</span>
                    <span v-else-if="scope.row.online_status==1">上班</span>
                    <span v-else>下班</span>
                </template>
            </el-table-column>
            <el-table-column prop="sendNames" label="账号状态" >
                <template #default="scope">
                    <span v-if="scope.row.account_status==0">禁用</span>
                    <span v-if="scope.row.account_status==1">启用</span>
                    <span v-if="scope.row.account_status==2">冻结</span>
                    <span v-if="scope.row.account_status==3">待审核</span>
                </template>
            </el-table-column>
            
            <el-table-column prop="seats_num" label="当前接待数" width="130" >
                <template #default="scope">
                    <span >{{ scope.row.seats_num }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="max_session_limit" label="最大接待数" width="130" >
                <template #default="scope">
                    <span >{{ scope.row.max_session_limit }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" width="260" label="创建时间" />
            <el-table-column  label="AI回复（离线）" width="130">
                <template #default="scope">
                   <el-button style="color:#4F46E5" size="small" type="text" @click="openpeizhi(scope.row)">配置</el-button>
                </template>
            </el-table-column>
            <el-table-column  label="AI回复（在线）" width="130">
                <template #default="scope">
                    <el-dropdown style="cursor: pointer;" @command="handleCommand($event,scope.row)">
                        <span class="el-dropdown-link">
                            <span v-if="scope.row.agent_switch==1">自动回复</span>
                            <span v-if="scope.row.agent_switch==0">关闭</span>
                            <span v-if="scope.row.agent_switch==2">半自动回复</span>
                            <el-icon class="el-icon--right">
                                <arrow-down />
                            </el-icon>
                        </span>
                        <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item command="auto">自动回复</el-dropdown-item>
                            <el-dropdown-item command="close">关闭</el-dropdown-item>
                            <el-dropdown-item command="semiauto">半自动回复</el-dropdown-item>  
                        </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </template>
            </el-table-column>
            <el-table-column prop="session_ephemeral_reply_switch" width="150" label="临时会话邀请" >
                <template #default="scope">
                    <el-switch v-model="scope.row.session_ephemeral_reply_switch" :active-value="1" :inactive-value="0" @change="changeMaxSessionLimit(scope.row,$event)" />
                </template>
            </el-table-column>
            <el-table-column  label="操作" width="300">
                <template #default="scope">
                    <el-button @click="openaipz(scope.row)" style="color:#4F46E5" size="small" type="text">Ai 配置</el-button>
                    <el-button style="color:#4F46E5" size="small" type="text" @click="openwindow(scope.row)">修改</el-button>
                    <el-button style="color:#4F46E5" size="small" type="text" @click="opennewpwd(scope.row)">修改密码</el-button>
                    <el-button style="color:#4F46E5" size="small" type="text" @click="delbtn(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
        <!-- 新增 -->
        <el-dialog
            v-model="isshowadd"
            :title="formdata.id?'修改账号':'添加账号'"
            width="500px"
            :close-on-click-modal="false">
            <div>
                <div  class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        账号
                    </div>
                    <el-input  v-model="formdata.username" placeholder="请输入账号名称"  clearable />
                </div>
                <div v-if="formdata.id==''" class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        密码
                    </div>
                    <el-input v-model="formdata.password" placeholder="请输入密码"  clearable />
                </div>
                <!-- <div class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        确认密码
                    </div>
                    <el-input v-model="formdata.passwordagain" placeholder="请再次输入密码"  clearable />
                </div> -->
                <div class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        昵称
                    </div>
                    <el-input v-model="formdata.nickname" placeholder="请输入昵称"  clearable />
                </div>
                <div class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        账号状态
                    </div>
                    <!-- <el-switch
                    style="margin-left: 15px;"
                     v-model="formdata.account_status"
                     :active-value="1"
                     :inactive-value="0" /> -->
                     <el-select
                        v-model="formdata.account_status"
                        placeholder="请选择"
                        >
                        <el-option label="禁用" :value="0"></el-option>
                        <el-option label="启用" :value="1"></el-option>
                       
                    </el-select>
                </div>
                <div class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        账号类型
                    </div>
                    <el-select
                        v-model="formdata.role"
                        placeholder="请选择"
                        >
                        <el-option
                            v-for="item in acctype"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
                <div class="t_form_item">
                    <div class="t_form_title">
                        <span>*</span>
                        在线状态
                    </div>
                    <el-select
                        v-model="formdata.online_status"
                        placeholder="请选择"
                        >
                        <el-option
                            v-for="item in onlinetype"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
                
            </div>
            <div class="t_cz_box">
                <el-button @click="isshowadd = false">取消</el-button>
                <el-button type="primary" color="#4F46E5" @click="suresub">确认</el-button>
            </div>
            
        </el-dialog>
        <!-- 修改密码 -->
         <el-dialog
            v-model="isshownewpwd"
            title="修改密码"
            width="500px"
        >
            <el-input v-model="newpwd" placeholder="请输入新密码"  clearable />
            <template #footer>
            <div class="dialog-footer">
                <el-button @click="isshownewpwd = false">取消</el-button>
                <el-button type="primary" @click="newpwdbtn">
                确定
                </el-button>
            </div>
            </template>
        </el-dialog>

        <!-- Ai 配置 -->
         <el-dialog
            v-model="isshowaipz"
            title="请选择知识库"
            width="600px"
        >
            <!-- <div class="t_aipz_tips">当前智能体：XXXXXX,   请选择回复用户依赖的知识库</div> -->
            <div class="t_aipz_select" @click="chooseknowbtn(item)" v-for="(item,index) in knowlist.data" :key="index">
                <div >
                    <div class="t_aipz_title">{{item.name}}</div>
                    <div class="t_aipz_count">{{item.active_num}}条知识</div>
                </div>
                <el-icon :class="{'t_choose_lei':item.selected==1}" style="font-size: 21px;"><SuccessFilled /></el-icon>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="isshowaipz = false">取消</el-button>
                    <el-button type="primary" color="#4F46E5" @click="sureaipz">
                    确定
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 临时会话邀请 -->
         <el-dialog
            v-model="isshowmaxsessionlimit"
            title="临时会话邀请"
            width="500px"
            :close-on-click-modal="false"
        >

            <el-upload
                :headers="headers"
                class="avatar-uploader"
                :action="upload_img"
                :data="upData"
                accept="image/jpg,image/jpeg,image/png"
                :show-file-list="false"
                :on-success="web_handleAvatarSuccess"
                :before-upload="web_beforeAvatarUpload">
                <img v-if="web_imgurl" :src="web_imgurl" class="avatar" />
                    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
            </el-upload>
            <el-input style="margin-top: 10px;" v-model="lincontent" :rows="4"
                type="textarea" placeholder="请输入邀请话术"  clearable /> 
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="isshowmaxsessionlimit = false">取消</el-button>
                    <el-button type="primary" @click="suremaxsessionlimit">
                    确认添加
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
    <!-- 配置弹窗 -->
    <el-dialog
        v-model="isshowpeizhi"
        title="AI回复配置"
        width="800"
        :close-on-click-modal="false"
    >
        <div  style="font-size: 15px;margin-bottom: 30px;margin-top: 30px;color:#ABABAB">7×24 小时 AI 替您自动回复，仅在您离线后生效。</div>
        <el-checkbox-group v-model="checkList.data" @change="changecompacc">
            <div v-for="(item,index) in allcomppeolist.data" :key="index">
                <div class="t_peizhi_title">{{item.corp_name}}</div>
                <div class="t_peizhi_device_box">
                    <div v-for="(item2,index2) in item.seats" :key="index2" >
                            <el-checkbox class="t_peizhi_device" :label="item2.internal_user_name" :value="item2.internal_user_id" />
                    </div>
                </div>
            </div>
        </el-checkbox-group>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="isshowpeizhi = false">取消</el-button>
            <el-button type="primary" @click="surepeizhi">
            确定
            </el-button>
        </div>
        </template>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { getacclist,delacc,addacc,editacc,newgetkflist,newcreatekf,neweditkf,newdelkf,neweditpwd,neweditaireply,newgetkonwlist,newselectkonw,newautoreply,newgetcomppeo,newgetcompandacc,neweditcompandaccoutline,newgetcompandaccoutline} from '@/assets/js/common.js'
import { itemsendlist } from '../assets/js/common'
//获取路由参数 
const route = useRoute()
//路由跳转
const router = useRouter()

//动态获取接口地址
const _url2 = inject('_url2')

const headers = {
  'Authorization': 'Bearer ' + $cookies.get("fanstoken")
}


onMounted(() => {
    console.log('onMounted')
    getlist()
    // getcomppeolist()
})


//AI回复
const handleCommand = (command,row)=>{
    console.log(command)
    console.log(row)
    if(command=='auto'){
        var obj = {
            id:row.id,
            agent_switch:1,
        }
    }
    else if(command=='close'){
        var obj = {
            id:row.id,
            agent_switch:0,
        }
    }
    else if(command=='semiauto'){
        var obj = {
            id:row.id,
            agent_switch:2,
        }
    }


    neweditaireply(obj).then((response)=>{
        if(response.data.msg.code==0){
            ElMessage({
                type: 'success',
                message: '操作成功',
            })
            getlist()
        }
        
    })
}

//搜索内容
const searchdata  = reactive({
   
    page:1,
    page_size:20,
    username:''
})

//搜索
const searchbtn = ()=>{
    searchdata.page=1
    getlist()
}

//重置
const resetsearch = ()=>{
    
    searchdata.page=1
    
    getlist()
}
//列表数据
const tableData = reactive({
    data:[]
})
//获取列表
const getlist = ()=>{
    newgetkflist(searchdata).then((response)=>{
        if(response.data.msg.code==0){
            console.log('---列表')
            console.log(response.data)
            
            tableData.data = response.data.data.data
            total.value = response.data.data.total
        }
        
    })
}
//成员总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}

//弹窗是否显示
const isshowadd = ref(false)

//删除
const delbtn = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelkf({id:id}).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                
                getlist()
            }
            
        })
      
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//在线状态
const isWorklist = [
    {
        value: 1,
        label: '上班'
    },
    {
        value: 2,
        label: '挂起休息'
    },
    {
        value: 0,
        label: '下班'
    }
]
//创建类型
const acctype = [
    {
        value: 0,
        label: '管理员'
    },
    {
        value: 1,
        label: '客服'
    },
    {
        value: 2,
        label: '运营者'
    }
]
//在线状态
const onlinetype = [
    {
        value: 0,
        label: '挂起休息'
    },
    {
        value: 1,
        label: '上班'
    },
    {
        value: 2,
        label: '下班'
    }
]
//打开弹窗
const openwindow = (row)=>{
    isshowadd.value = true
    if(row){
        //编辑
        formdata.id = row.id
        formdata.username = row.username
        // formdata.password = row.plain_password
        // formdata.passwordagain = row.password
        formdata.nickname = row.nickname
        formdata.account_status = row.account_status
        formdata.role = row.role
        formdata.online_status = row.online_status
        
    }else{
        //新增
        formdata.id = ''
        formdata.username = ''
        formdata.password = ''
        // formdata.passwordagain = ''
        formdata.nickname = ''
        formdata.account_status = 1
        formdata.role = 0
        formdata.online_status = 1
    }
}
//提交表单
const formdata = reactive({
    id:'',
    username:'',
    password:'',
    // passwordagain:'',
    nickname:'',
    account_status:1,
    role:0,
    online_status:1
})
// 提交
const suresub = ()=>{
    if(formdata.id==''){
        if(formdata.username==''||formdata.password==''||formdata.nickname==''){
            ElMessage.error('信息未填写完整')
            return
        }
    }
    
    // if(formdata.password!=formdata.passwordagain){
    //     ElMessage.error('密码输入不一致')
    //     return
    // }
    
    if(formdata.id==''){
        //新增
        newcreatekf(formdata).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                searchdata.page = 1
                getlist()
                isshowadd.value = false
            }
            
        })
    }else{
        //编辑
        //去掉密码
        delete formdata.password

        neweditkf(formdata).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                getlist()
                isshowadd.value = false
            }
            
        })
    }
}
//修改密码
const newpwd = ref('')
const nowchoose = reactive({
    data:{}
})
const isshownewpwd = ref(false)
const opennewpwd = (row)=>{
    isshownewpwd.value = true
    nowchoose.data = row
}
const newpwdbtn = ()=>{
    if(newpwd.value==''){
        ElMessage.error('请输入新密码')
        return
    }

    ElMessageBox.confirm(
    '是否确认操作?',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        neweditpwd({
            id:nowchoose.data.id,
            password:newpwd.value
        }).then((response)=>{
            if(response.data.msg.code==0){
                isshownewpwd.value = false
                newpwd.value = ''
                getlist()
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
            }
            
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: 'Delete canceled',
      })
    })
}

//Ai 配置
const isshowaipz = ref(false)
const knowlist = reactive({
    data:[]
})
//选中的知识库
const chooseknow = reactive({
    data:[]
})

//当前选中的客服
const nowchoosekefu = reactive({
    data:{}
})



const openaipz = (row)=>{
    isshowaipz.value = true
    nowchoosekefu.data = row
    newgetkonwlist({
       to_employee_id:row.id
    }).then((response)=>{
        if(response.data.msg.code==0){
            console.log(response.data.data)
            knowlist.data = response.data.data
            chooseknow.data = response.data.data.filter((item)=>{
                return item.selected==1
            })
        }
    })
    
}

//选择知识库
const chooseknowbtn = (item)=>{
    console.log(item)
    //判断已选里有没有，有就删除当前对象，没有就加入数组
    const index = chooseknow.data.findIndex((ele)=>ele.id===item.id)
    if(index!==-1){
        chooseknow.data.splice(index,1)
        item.selected = 0
    }else{
        chooseknow.data.push(item)
        item.selected = 1
    }
    console.log(chooseknow.data)
}

const sureaipz = ()=>{

    newselectkonw({
        to_employee_id:nowchoosekefu.data.id,
        list:chooseknow.data
    }).then((response)=>{
        if(response.data.msg.code==0){
            ElMessage({
                type: 'success',
                message: '操作成功',
            })
            getlist()
            isshowaipz.value = false
        }
    })



    
}


//临时会话邀请
const isshowmaxsessionlimit = ref(false)
//当前选中的客服
const nowchoosekefurow = reactive({
    data:{}
})
//临时会话邀请内容
const lincontent = ref('')
//临时会话邀请
const changeMaxSessionLimit = (row,event)=>{
    console.log(row,event)
    nowchoosekefurow.data = row
    if(event==1){
        var obj = {
            auto_reply_switch:1,
            employee_id:row.id,
            link:row.session_auto_reply_material.link,
            content:row.session_auto_reply_material.content
        }
        web_imgurl.value = row.session_auto_reply_material.link
        lincontent.value = row.session_auto_reply_material.content
        
    }else{
        var obj = {
            auto_reply_switch:0,
            employee_id:row.id,
            link:row.session_auto_reply_material.link,
            content:row.session_auto_reply_material.content
        }
    }

    newautoreply(obj).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                if(event==1){
                    isshowmaxsessionlimit.value = true
                }else{
                    getlist()
                }
                
            }
        })
}
//临时会话邀请
const suremaxsessionlimit = ()=>{
    if(lincontent.value==''){
        ElMessage.error('请输入邀请话术')
        return
    }
    if(web_imgurl.value==''){
        ElMessage.error('请上传图片')
        return
    }

    newautoreply({
        auto_reply_switch:1,
        employee_id:nowchoosekefurow.data.id,
        link:web_imgurl.value,
        content:lincontent.value
    }).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                isshowmaxsessionlimit.value = false
                getlist()
            }
        })
}

//上传图片=======
const upload_img = '/api/common/upload'
const upData=reactive(
  { file_type: '' }
)  // 上传文件data
//回显地址
const web_imgurl = ref('')


//上传成功
const web_handleAvatarSuccess = (response,uploadFile)=>{
    web_imgurl.value = response.data.url
    console.log('上传成功')
    console.log(response)
    console.log(web_imgurl.value)
}
//上传前检测
const web_beforeAvatarUpload = (rawFile)=>{
    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
   
    upData.file_type = 'image'
    return true
}

//配置弹窗
const isshowpeizhi = ref(false)
//配置弹窗
const nowchoosekefupeizhi = reactive({
    data:{}
})
//打开配置弹窗
const openpeizhi = (row)=>{
    isshowpeizhi.value = true
    nowchoosekefupeizhi.data = row
    //清空上次选中的成员，避免展示残留数据
    checkList.data = []
    console.log('当前选中的客服')
    console.log(row)
    getcomppeolist(row.id)
}

//获取主体+成员下拉
const allcomppeolist = reactive({
    data:[]
})

const platform_employee_id = ref('')
//获取主体+成员下拉
const getcomppeolist = (val)=>{
    console.log('2222----')
    console.log(val)
    platform_employee_id.value = val
    newgetcompandacc({platform_employee_id:platform_employee_id.value}).then((response)=>{
        if (response.data.msg.code == 0) {
            
            allcomppeolist.data = response.data.data
           console.log('主体+成员')
            console.log(allcomppeolist.data)

            newgetcompandaccoutline({platform_employee_id:platform_employee_id.value}).then((response)=>{
                if(response.data.msg.code==0){
                   console.log('ai 离线回复配置')
                   console.log(response.data.data)
                   nowchoosekefupeizhioutline.data = response.data.data
                   if(nowchoosekefupeizhioutline.data.corps.length>0){
                        for(let i=0;i<nowchoosekefupeizhioutline.data.corps.length;i++){
                            for(let j=0;j<nowchoosekefupeizhioutline.data.corps[i].internal_user_ids.length;j++){
                                checkList.data.push(nowchoosekefupeizhioutline.data.corps[i].internal_user_ids[j])
                            }
                        }
                   }else{
                        checkList.data = []
                   }
                }
            })
        }
    })
}

//当前 ai 离线配置
const nowchoosekefupeizhioutline = reactive({
    data:{
        corps:[],
        id:'',
        platform_employee_id:'',
        platform_id:'',
        switch:''
    }
})

//选中的主体+成员
const checkList = reactive({
    data:[]
})
//选中的主体+成员
const changecompacc = (val)=>{
    console.log(val)
}

const surepeizhi = ()=>{

    var obj = {
        "platform_employee_id":nowchoosekefupeizhi.data.id,
        "id": nowchoosekefupeizhioutline.data.id,
        "switch": 1,
        "corps": []
    }

        const generateCorpsData = () => {
            const result = []
            const userIds = checkList.data || []
            const corpMap = new Map()
            allcomppeolist.data.forEach(corp => {
                corp.seats.forEach(seat => {
                    if (userIds.includes(seat.internal_user_id)) {
                        if (!corpMap.has(corp.corp_id)) {
                            corpMap.set(corp.corp_id, [])
                        }
                        corpMap.get(corp.corp_id).push(seat.internal_user_id)
                    }
                })
            })
            corpMap.forEach((internal_user_ids, corp_id) => {
                result.push({
                    corp_id,
                    internal_user_ids
                })
            })
            return result
        }

        obj.corps = generateCorpsData()

        console.log(obj)

        neweditcompandaccoutline(obj).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                isshowpeizhi.value = false
                getlist()
            }
        })
}

</script>
<style scoped>


:deep(.t_search_select .select-trigger) {
    width:100%
}

:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.t_form_item{
    background-color: #F1F3F9;
    display: flex;
    align-items: center;
    padding-left: 10px;
    margin-bottom: 20px;
}
:deep(.t_form_item .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
    
}
:deep(.t_form_item .el-input)  {
    width: 300px;
    
}
.t_form_title{
    width: 80px;
    text-align: right;
}
.t_form_title span{
   color: #F56C6C;
}
.t_aipz_tips{
    color: #8E8E8E;
    font-size: 15px;
}
.t_aipz_select{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #F1F3F9;
    box-shadow: 0 0  5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;

}
.t_aipz_select:hover{
    background-color: #E8F5FF;
}
.t_aipz_title{
    font-size: 17px;
    color: black;
}
.t_aipz_count{
    font-size: 15px;
    color: #B7B7B7;
    margin-top: 5px;
}
.t_choose_lei{
    color: #04C000;
}
.avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar2 {
    width: 178px;
    height: 178px;
    display: block;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
  }
 :deep(.avatar-uploader .el-upload)  {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep(.avatar-uploader .el-upload:hover)  {
  border-color: var(--el-color-primary);
}

:deep(.el-icon.avatar-uploader-icon)  {
  font-size: 29px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
:deep(.t_form_item .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.t_peizhi_title{
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    color: black;
}
.t_peizhi_device{
    margin-bottom: 5px;
    margin-right: 20px;
}
.t_peizhi_device_box{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
</style>